import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Input, List, Avatar } from "antd";
import UserLogin from "./forms/UserLogin";
import { PersonLinesFill, HouseFill, FilePostFill, Activity, Globe2, SaveFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var HomeContent = function HomeContent() {
  var data = [{
    title: 'Gerez vos compte client',
    avatar: /*#__PURE__*/_jsx(HouseFill, {
      size: 30
    }),
    description: "Retrouvez l'etats de vos comptes clients avec facilité"
  }, {
    title: 'Gérer les dossiers patients',
    avatar: /*#__PURE__*/_jsx(PersonLinesFill, {
      size: 30
    }),
    description: "Afficher le dossier medical de n'importe quel client"
  }, {
    title: 'Visualiser les dossiers médicaux',
    avatar: /*#__PURE__*/_jsx(FilePostFill, {
      size: 30
    }),
    description: "Visionner avec confort le dossier patients"
  }, {
    title: "Enregistrez vos consultations",
    avatar: /*#__PURE__*/_jsx(Activity, {
      size: 30
    }),
    description: "Enregistrer toutes les consultations sur un patient"
  }, {
    title: "Stoquez les resultats d'analyses",
    avatar: /*#__PURE__*/_jsx(SaveFill, {
      size: 30
    }),
    description: "Gardez les resultats d'analyse patient et affichez au besoin"
  }, {
    title: "Pourtout ou vous vous trouvez",
    avatar: /*#__PURE__*/_jsx(Globe2, {
      size: 30
    }),
    description: "Le tout accessible en un clique, ou que vous soyez"
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "page-container",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: {
              span: 5
            },
            md: {
              span: 5
            },
            sm: 7,
            children: /*#__PURE__*/_jsxs("div", {
              className: "home-right-box",
              children: [/*#__PURE__*/_jsx(UserLogin, {}), /*#__PURE__*/_jsx("div", {
                className: "hlogo"
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: {
              span: 5,
              offset: 2
            },
            md: {
              span: 5,
              offset: 2
            },
            sm: 6,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("img", {
                src: "drawables/homeimg.png",
                style: {
                  width: '100%'
                }
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("br", {})]
  });
};
export default HomeContent;